import { sending } from 'owa-locstrings/lib/strings/sending.locstring.json';
import {
    errorAsyncSendTimeout,
    saving,
    messageIsSentInfo,
} from './ComposeBottomEditorSendHost.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
const styles = require('./ComposeBottom.scss');
import { ComposeViewState, AsyncSendState } from 'owa-mail-compose-store';
import { Icon } from '@fluentui/react/lib/Icon';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { ControlIcons } from 'owa-control-icons';

interface ComposeBottomEditorSendHostProps {
    viewState: ComposeViewState;
    children?: React.ReactNode;
}

/**
 * The part of the compose editor underneath the editor ribbon.
 * Renders the approrpiate spinners / text based on the send state of the compose.
 *
 * If the compose is not sending or sent, falls through to rendering the children of the component.
 */
const ComposeBottomEditorSendHost = observer(function ComposeBottomEditorSendHost(
    props: ComposeBottomEditorSendHostProps
) {
    const { asyncSendState, isInlineCompose, isSending, isSavingSpinnerShown } = props.viewState;

    if (isSending) {
        if (asyncSendState == AsyncSendState.Timeout) {
            // For async send timeout, we are in floating compose now, so show the timeout info
            return (
                <div className={styles.buttonBar}>
                    <div className={styles.composeBottomStatusText}>
                        {loc(errorAsyncSendTimeout)}
                    </div>
                </div>
            );
        } else {
            // Sync send, or async send before client side validation finished
            return isInlineCompose ? (
                // For inline compose, we don't have commanding bar, so show spinner here
                <div className={styles.buttonBar}>
                    <Spinner className={styles.composeSpinner} />
                    <div className={styles.composeSpinnerText}>{loc(sending)}</div>
                </div>
            ) : (
                // Full compose, spinner is showing in commanding bar, just show the empty DIV to provide bottom border;
                <div className={styles.buttonBar} />
            );
        }
    } else if (isSavingSpinnerShown) {
        // For saving, render a spinner with saving text
        return (
            <div className={styles.buttonBar}>
                <Spinner className={styles.composeSpinner} />
                <div className={styles.composeSpinnerText}>{loc(saving)}</div>
            </div>
        );
    } else if (asyncSendState == AsyncSendState.Sent) {
        return (
            <div className={styles.buttonBar}>
                <Icon iconName={ControlIcons.CheckMark} className={styles.toastIcon} />
                <div className={styles.composeBottomStatusText}>{loc(messageIsSentInfo)}</div>
            </div>
        );
    } else {
        return <>{props.children}</>;
    }
});
export default ComposeBottomEditorSendHost;
